import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const ReferralPanelOverlay = (props: SvgProps) => (
  <Svg width="200" height="200" viewBox="0 0 200 200" fill="none" {...props}>
    <path
      d="M12 76V110C12 113.314 14.6863 116 18 116H55"
      stroke="white"
      strokeOpacity="0.75"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </Svg>
);

export default ReferralPanelOverlay;
